module.exports = __webpack_public_path__ + "img/165-Shogun AC.jpg";